import { BrowserRouter } from 'react-router-dom'
import posthog from 'posthog-js'
import { PostHogErrorBoundary, PostHogProvider } from '@posthog/react'
import { Toaster } from '~/shadcn/ui/sonner'
import { BrowserTranslateDetector } from '~/@lib_integrations/translate-detection/BrowserTranslateDetector'
import { PostHogUserTracker } from '~/@lib_integrations/posthog/PostHogUserTracker'
import { SmartsUpp } from '~/@lib_integrations/smartsupp/Smartsupp'
import { AnalyticsProvider } from '~/@lib_integrations/analytics/AnalyticsProvider'
import { AppErrorFallback } from '~/@mid_ui/app-error-fallback/AppErrorFallback'
import { Footer } from '~/@mid_ui/footer/Footer'
import { QueryClientProvider } from '~/@mid_query/client/QueryClientProvider'
import { AppRouter } from '~/@biz_router/AppRouter'
import { AppDialogs } from '~/@biz_app-dialogs/AppDialogs'
import { ScrollToTop } from '~/@biz_router/helper-routes/ScrollToTop'
import { useAuthenticated } from '~/@pages_auth/_auth/useAuthenticated'
import { DevWidget } from '~/@dev-buttons/DevWidget'
import { BuildTime } from '~/@dev-build-time/buildTime/BuildTime'

function App() {
  return (
    // `client={posthog}` = už inicializovaný singleton z `initPostHog.ts` (import v main.tsx).
    <PostHogProvider client={posthog}>
      <QueryClientProvider>
        <BuildTime />
        <BrowserRouter>
          <AnalyticsProvider />
          <ScrollToTop />
          {/* Must be mounted BEFORE AppContent: React runs sibling effects in order, so
              posthog.identify() fires before the post-login redirect captures its $pageview. */}
          <PostHogUserTracker />
          <div className="min-h-screen">
            {/* Render chyby → PostHog `$exception` + fallback UI (náhrada Sentry.ErrorBoundary). */}
            <PostHogErrorBoundary fallback={<AppErrorFallback />}>
              <AppContent />
            </PostHogErrorBoundary>
          </div>
          <Footer />

          <Toaster />
          <AppDialogs />

          {/* Chat */}
          <SmartsUpp />

          {/* Analytics */}

          <BrowserTranslateDetector />

          {/* ONLY FOR DEV MODE */}
          {import.meta.env.VITE_HIDE_DEV !== 'true' && <DevWidget />}
        </BrowserRouter>
      </QueryClientProvider>
    </PostHogProvider>
  )
}

function AppContent() {
  const { hasAuthToken } = useAuthenticated()

  return <AppRouter isAuthenticated={hasAuthToken} />
}

export default App
